import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Typography from '@material-ui/core/Typography';
import {
  CELL_LAYOUT_TYPE,
  LABELLED_LAYOUT_TYPE,
  FULL_LAYOUT_TYPE,
} from './Types';
import './FilterDialogPanel.scss';

const cellConfigToStyle = (config) => {
  const styles = {};
  if (config.span) {
    styles.gridRowEnd = `span ${config.span}`;
  } else if (config.column) {
    styles.gridColumn = config.column;
  }
  return styles;
};

const EMPTY_OBJECT = {};

const FilterDialogPanel = (props) => {
  const {
    onValueChange,
    editorsByLayoutType,
    dialogValue,
    dialogErrors,
    tabId,
    defaultTabId,
    ...rest
  } = props;
  const matchPanel = ({ editor }) => {
    return !tabId || (!editor.tab && (tabId === defaultTabId)) || (editor.tab === tabId);
  };
  const dependentProps = useCallback((editor) => {
    return editor.dependsOn
      ? editor.dependsOn.reduce((values, editorName) => {
          values[editorName] = dialogValue[editorName];
          return values;
        }, {})
      : EMPTY_OBJECT;
  }, [dialogValue]);
  return (
    <div className="grb-filter-dialog-panel">
      {editorsByLayoutType[CELL_LAYOUT_TYPE] && (
        <div className="grb-filter-dialog-cell-editors grbrsm-cell-editors">
          {editorsByLayoutType[CELL_LAYOUT_TYPE].filter(matchPanel).map(({ editor, Component }) => (
            <Component
              className={classnames('grb-filter-dialog-cell-editor grbrsm-cell-editor', editor.className)}
              {...rest}
              {...dependentProps(editor)}
              key={editor.name}
              value={dialogValue[editor.name]}
              editor={editor}
              error={dialogErrors && dialogErrors[editor.name]}
              onValueChange={onValueChange(editor)}
              style={editor.layoutConfig ? cellConfigToStyle(editor.layoutConfig) : undefined}
            />
          ))}
        </div>
      )}
      {editorsByLayoutType[LABELLED_LAYOUT_TYPE] && (
        <div className="grb-filter-dialog-labelled-editors grbrsm-labelled-editors">
          {editorsByLayoutType[LABELLED_LAYOUT_TYPE].filter(matchPanel).map(({ editor, Component }) => (
            <React.Fragment key={editor.name}>
              <div className="grb-filter-dialog-editor-name grbrsm-filter-dialog-editor-name" key={`dialog-title-${editor.name}`}>
                <Typography variant="body2">{editor.title}</Typography>
              </div>
              <div
                className={classnames('grb-filter-dialog-editor-body grbrsm-filter-dialog-editor-body', editor.className)}
                key={`dialog-body-${editor.name}`}
              >
                <Component
                  {...rest}
                  {...dependentProps(editor)}
                  key={editor.name}
                  value={dialogValue[editor.name]}
                  editor={editor}
                  error={dialogErrors && dialogErrors[editor.name]}
                  onValueChange={onValueChange(editor)}
                />
              </div>
            </React.Fragment>
          ))}
        </div>
      )}
      {editorsByLayoutType[FULL_LAYOUT_TYPE] && (
        <div className="grb-filter-dialog-full-editors grbrsm-full-editors">
          {editorsByLayoutType[FULL_LAYOUT_TYPE].filter(matchPanel).map(({ editor, Component }) => (
            <Component
              {...rest}
              {...dependentProps(editor)}
              key={editor.name}
              className={editor.className}
              value={dialogValue[editor.name]}
              error={dialogErrors && dialogErrors[editor.name]}
              editor={editor}
              onValueChange={onValueChange(editor)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

FilterDialogPanel.propTypes = {
  tabId: PropTypes.string,
  defaultTabId: PropTypes.string,
  onValueChange: PropTypes.func.isRequired,
  editorsByLayoutType: PropTypes.shape({}).isRequired,
  dialogValue: PropTypes.shape({}).isRequired,
  dialogErrors: PropTypes.shape({}),
};

FilterDialogPanel.defaultProps = {
  tabId: undefined,
  defaultTabId: undefined,
  dialogErrors: {},
};

export default FilterDialogPanel;
